import { render, staticRenderFns } from "./addActive.vue?vue&type=template&id=31586b5c&scoped=true"
import script from "./addActive.vue?vue&type=script&lang=js"
export * from "./addActive.vue?vue&type=script&lang=js"
import style0 from "./addActive.vue?vue&type=style&index=0&id=31586b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31586b5c",
  null
  
)

export default component.exports